import IDataFilters from './data/iDataFilters';

export const UNKNOWN_LOCATION_NAME = '(unknown building)';

export const DEFAULT_FILTERS: Readonly<IDataFilters> = {
  onOrAfter: undefined,
  onOrBefore: undefined,
  salesChannels: [],
  hideNotToProduction: false,
  showTypes: 'all',
};
